export class InfoBlock {
    /**
     * @type string
     * @private
     */
    _id;

    _timeout;

    constructor (id) {
        this._id = id;
    }

    isDisplayed () {
        return this.tab.classList.contains('active');
    }

    get tab () {
        return document.querySelector('#tab-' + this._id);
    }

    get title () {
        return document.querySelector('#title-' + this._id);
    }

    get content () {
        return document.querySelector('#content-' + this._id);
    }

    get image () {
        return document.querySelector('#image-' + this._id);
    }

    display () {
        this.resetAnimation();

        this.title.style.display = '';
        this.content.style.display = '';

        this.tab.classList.add('active');
        this.title.classList.add('active');
        this.content.classList.add('active');
        this.image.classList.add('active');
    }

    hide () {
        this.resetAnimation();

        this.tab.classList.remove('active');
        this.title.classList.remove('active');
        this.content.classList.remove('active');
        this.image.classList.remove('active');

        this._timeout = setTimeout(() => {
            this.title.style.display = 'none';
            this.content.style.display = 'none';
        }, 300);
    }

    resetAnimation () {
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
    }
}
